<!-- @format -->
<template>
    <p>{{ $t('description') }}</p>
</template>
<script>
export default {
    name: 'BookingContentStatusCancelled',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking.bookingContent.cancelled',
    },
};
</script>
